module.exports = __webpack_public_path__ + "media/src/images/mails/linkedin-0785e1396f4b1081a185eb12b142ccc4.png";